import { Link } from "react-router-dom";

export const LEGAL_TEXT =
  "© 2026 The Queue. All rights reserved. The Queue™, The Queue Home Hub™, the Q logo and “Software for you”™ are trademarks of The Queue.";

export function HouseQ({ size = 32, className = "", title = "The Queue" }) {
  return (
    <svg width={size} height={size} viewBox="272 272 1388 1388" role="img" aria-label={title} className={className}
      style={{ flexShrink: 0 }} data-testid="brand-mark">
      <circle cx="966" cy="966" r="674" fill="#F47920" />
      <polygon points="1345,1525 1500,1378 1607,1487 1459,1635" fill="#F47920" />
      <circle cx="966" cy="943" r="309" fill="none" stroke="#0D0D0D" strokeWidth="166" />
      <polygon points="1166,1281 1278,1180 1366,1264 1260,1369" fill="#0D0D0D" />
      <path d="M966 762 L1048 846 L1048 807 L1083 807 L1083 882 L1128 928 L1090 928 L1090 1098 L994 1098 L994 1031 A28 28 0 0 0 938 1031 L938 1098 L841 1098 L841 928 L803 928 Z" fill="#0D0D0D" />
    </svg>
  );
}

export function Wordmark({ tm = false, className = "" }) {
  return (
    <span className={`font-display font-extrabold tracking-[-0.02em] text-q-wordmark ${className}`}>
      The Queue{tm && <sup className="ml-0.5 text-[0.4em] font-bold align-super">™</sup>}
    </span>
  );
}

export function Lockup({ size = "lg", tm = false }) {
  const big = size === "lg";
  return (
    <div className="flex flex-col items-center text-center" data-testid="brand-lockup">
      <HouseQ size={big ? 132 : 72} />
      <Wordmark tm={tm} className={big ? "mt-6 text-5xl sm:text-6xl" : "mt-4 text-3xl"} />
      <span className={`mt-2 font-semibold uppercase text-q-muted ${big ? "text-xs tracking-[0.42em]" : "text-[10px] tracking-[0.38em]"}`}>
        Software for you
      </span>
    </div>
  );
}

export function LegalFooter({ className = "" }) {
  return (
    <footer className={`px-6 py-8 text-center text-[11px] leading-relaxed text-q-faint ${className}`} data-testid="legal-footer">
      <nav className="mb-2 flex justify-center gap-4 text-xs font-semibold" aria-label="Legal">
        <Link to="/privacy" className="text-q-muted hover:text-q-text hover:underline" data-testid="footer-privacy-link">Privacy Policy</Link>
        <Link to="/terms" className="text-q-muted hover:text-q-text hover:underline" data-testid="footer-terms-link">Terms of Service</Link>
      </nav>
      {LEGAL_TEXT}
    </footer>
  );
}

export function PublicLayout({ children }) {
  return (
    <div className="relative flex min-h-screen flex-col bg-q-bg">
      <header className="flex items-center justify-between px-5 py-4 sm:px-8">
        <Link to="/" className="flex items-center gap-2.5" data-testid="public-home-link">
          <HouseQ size={30} />
          <span className="font-display text-[15px] font-extrabold text-q-wordmark">The Queue</span>
          <span className="hidden text-[10px] font-semibold uppercase tracking-[0.3em] text-q-faint sm:inline">Home Hub</span>
        </Link>
      </header>
      <main className="flex flex-1 items-start justify-center px-5 pb-6 pt-4 sm:items-center">{children}</main>
      <LegalFooter />
    </div>
  );
}
